import { RootState } from 'models';

const getIsOpen = (state: RootState) => state.chatbot.isOpen;

const getDisplayMode = (state: RootState) => state.chatbot.displayMode;

const getIsMinimized = (state: RootState) => state.chatbot.isMinimized;

const getMessages = (state: RootState) => state.chatbot.messages;

const getHistoryMessages = (state: RootState) => state.chatbot.historyMessages;

const getLoading = (state: RootState) => state.chatbot.loading;

const getSelectedModal = (state: RootState) => state.chatbot.selectedModel;

const getUseNeighbors = (state: RootState) => state.chatbot.useNeighbors;

const getTools = (state: RootState) => state.chatbot.tools;

const getModels = (state: RootState) => state.chatbot.models;

const getTemperature = (state: RootState) => state.chatbot.temperature;

const getSuppressHistory = (state: RootState) => state.chatbot.suppressHistory;

const getToolsEnabled = (state: RootState) => state.chatbot.toolsEnabled;

const getSuppressContext = (state: RootState) => state.chatbot.suppressContext;

const getOnlyValidated = (state: RootState) => state.chatbot.onlyValidated;

const getSessionId = (state: RootState) => state.chatbot.sessionId;

const getHasChatbotAdvancedConfig = (state: RootState) => state.chatbot.hasChatbotAdvancedConfig;

const getFeedbackStates = (state: RootState) => state.chatbot.feedbackStates;

const getWalkthroughState = (state: RootState) => state.chatbot.walkthrough;

const getWalkthroughRefreshKey = (state: RootState) => state.chatbot.walkthrough.refreshKey;

const getCurrentWalkthroughStep = (state: RootState) => {
  const walkthrough = state.chatbot.walkthrough;
  return walkthrough.steps.find((s) => s.id === walkthrough.currentStepId) || null;
};

export default {
  getIsOpen,
  getDisplayMode,
  getIsMinimized,
  getMessages,
  getHistoryMessages,
  getLoading,
  getSelectedModal,
  getUseNeighbors,
  getTools,
  getModels,
  getTemperature,
  getSuppressHistory,
  getToolsEnabled,
  getSuppressContext,
  getOnlyValidated,
  getSessionId,
  getHasChatbotAdvancedConfig,
  getFeedbackStates,
  getWalkthroughState,
  getWalkthroughRefreshKey,
  getCurrentWalkthroughStep,
};
